import React from "react";
import { IPanelProps, Panel } from "core/decorators/Panel";
import Icon from "common/views/icon/Icon";
import { CardView } from "common/views/card/Card.view";
import TypographyView from "common/views/typographyView/Typography.view";
import { Entity, Field ,Operation} from "typegraph";
import { IQueryRoot, QueryRoot } from "core/decorators/QueryRoot";
import initialState from "core/reducers/initialState";
import { ID } from "common/entities/IEntity";
import PageLinkView from "common/views/pageLink/PageLink.view";
import { IBreadcrumb } from "core/util/IBreadcrumb";
import { lastItem } from "core/util/ArrayUtil";
import UrlUtil from "core/util/UrlUtil";
import { ButtonVariant, ButtonView } from "common/views/button/Button.view";
import ServiceRegistry from "core/util/ServiceRegistry";

class OthereViewedCourse {
	@Field()
	public entryId: string; 

	@Field()
	public name: string;

	@Field()
	public externalId: string;
	@Field()
		
	public hidden: boolean;
	@Field()
		
	public deleted: boolean;
	@Field()
		
	public standalone: boolean;
	@Field()
		
	public subscriptionBased: boolean;
}

function mapCourseParams(params: any = {}) {
	return { params };
}

@Operation({type: "query", name: "geViewedList"})
class CourseQuery {
	@Field({entity: OthereViewedCourse, aliasFor: "other_viewed_courses", params: mapCourseParams})
	public courses: null | OthereViewedCourse[];
}

function mergeConfigAndParams(pageParams: { [key: string]: string; }, user: typeof initialState.user) {
	const queryString = window.location.search;
	const params = new URLSearchParams(queryString)
	const p = { entryId: params.get('entryId')};
	return p;
}

export interface OthersCourseViewedState {
	display: boolean; 
}

@Entity({ update: "activity" })
export class updateOnAdd {
	@Field()
	public userId: string;
	@Field()
	public entityId: string;
}


@Panel({ id: "others-course-view",pageParams: true })
@QueryRoot(CourseQuery, mergeConfigAndParams)
class OthersCourseViewed extends React.PureComponent<IQueryRoot<CourseQuery>> {

	public state: OthersCourseViewedState = {
		display: false,
	};

	private handleHideShow() {
		this.setState({display:!this.state.display})
	}

	componentDidMount(): void {
		const param = { entityId: "", activityTypeId: "" } as any;
		param.entityId = this.props["pageParams"] && this.props["pageParams"]["itemId"] ?this.props["pageParams"]["itemId"] : "";
		param.activityTypeId = "1";
		ServiceRegistry.getMutationService()
			.update(param, updateOnAdd)
			.then(res => {
				console.log("Others viewed saved successfully")
			})
			.catch(err => {
				console.log("Error : "+err)
			});
	}

	public render() {
		const {queryData } = this.props;
		const { courses } = (queryData || {} as CourseQuery);

		return (
			<CardView viewKey="course.otherViewed">
				<div style={{ textAlign: "left" }}>
					<div style={{ display: "flex", gap: "10px", cursor :"pointer", width:"fit-content", color:"black"}} onClick={() => this.handleHideShow()}>
						<div><TypographyView viewKey="course.viewed.label">Others who viewed this also viewed </TypographyView> </div>
						<div>{ this.state.display ? <Icon icon="chevron-down" /> : <Icon icon="chevron-left" />}</div>
					</div>
					{
						this.state.display && courses && courses.length && courses.map((course) => {
							return (
								<PageLinkView
									attrs={
										course && {
											"data-wap_ref": `${course.entryId}:${
												course.name
											}`
										}
									}
									params={{
										entryId: course && course.entryId,
									}}
									viewKey="course.detailsLink.link"
									breadcrumbs={(target, breadcrumbs) => {
										let nextCrumbs: IBreadcrumb[] = [];
										const courseKey = "course:" + course.entryId;
										// push current page's crumb
										const lastCrumb = lastItem(breadcrumbs);

										const currentPath = UrlUtil.getCurrentPath();
										// if last crumb was for the current page and has a target, use that one
										if (
											lastCrumb &&
											lastCrumb.target.pathname === currentPath
										) {
											nextCrumbs = [
												...breadcrumbs.slice(0, breadcrumbs.length - 1),
												{
													...lastCrumb,
													target: {
														pathname: currentPath,
														search: UrlUtil.getSearch()
													}
												}
											];
										} else if (
											// if last crumb was for the current page and has no target path associated
											lastCrumb &&
											lastCrumb.target.pathname === ""
										) {
											nextCrumbs = [
												...breadcrumbs.slice(0, breadcrumbs.length - 1),
												{
													...lastCrumb,
													target: {
														pathname: currentPath,
														search: UrlUtil.getSearch()
													}
												}
											];
										} else {
											// else create a new one for the current page
											nextCrumbs = [
												...breadcrumbs,
												{
													key: "course-detail",
													label: {
														k: courseKey,
														v:
															window.parent.location.pathname.slice(
																1
															) || "Home"
													},
													target: {
														pathname: currentPath,
														search: UrlUtil.getSearch()
													}
												}
											];
										}

										// push article crumb
										nextCrumbs.push({
											key: courseKey,
											label: {
												k: courseKey,
												v: course.name
											},
											//target
											target: {
												pathname: "",
												search: ""
											}
										});

										return nextCrumbs;
									}}
								>
									<div style={{cursor:"pointer", marginTop:"10px"}}>
										<ButtonView variant={ButtonVariant.SECONDARY} viewKey="course.detailsLink.button">
											{ course.name}
										</ButtonView>
									</div>
								</PageLinkView>
							)
						})
					}
					
			    </div>
			</CardView>
			)
	}
}



// WEBPACK FOOTER //
// ./src/panels/othersCourseViewed/OthersCourseView.panel.tsx